<app-fire-foresight-menu></app-fire-foresight-menu>

<!-- BEGIN #content -->
<div id="content" class="app-content">

  <div class="modal fade" bsModal #responsibleModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Responsible Party</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="responsibleModal.hide()"></button>
        </div>
        <div class="modal-body">
          <i>Who is the responsible party?</i>
          <div class="d-block wide pt-4">
            <!-- Phone Display -->
            <button type="button" class="btn btn-block btn-outline-default wide mt-3" *ngFor="let rp of responsibleParties"
              (click)="escalate(rp.responsiblePartyId);responsibleModal.hide()" style="border-color: {{rp.colour}};" >{{rp.displayName}}</button>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="responsibleModal.hide()" class="btn btn-white">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" bsModal #falsePositiveModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">False Positive</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="falsePositiveModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="d-block wide pt-4">
            <!-- Phone Display -->
            <button type="button" class="btn btn-block btn-outline-default wide mt-3" *ngFor="let rp of falsePositiveTypes"
              (click)="notAFire(rp.falsePositiveTypeId);falsePositiveModal.hide()">{{rp.displayName}}</button>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="falsePositiveModal.hide()" class="btn btn-white">Cancel</button>
        </div>
      </div>
    </div>
  </div>

<div class="row wrapper border-bottom white-bg page-heading">


<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row mt-2">
    <div class="col-12">

      <div class="card">
				<div class="card-body p-0">
					<!-- BEGIN profile -->
					<div class="profile">
						<!-- BEGIN profile-container -->
						<div class="profile-container">
							<!-- BEGIN profile-sidebar -->
							<div class="profile-sidebar">
								<div class="mt-2">
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Fire Foresight - AI'"><i class="bi bi-camera  text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Robotic Cats AI'"><i class="fa fa-camera text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Fire Foresight AI'"><i class="fa fa-camera text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Lightning'"><i class="fa fa-bolt fa-fw text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Sensor'"><i class="fa fa-signal fa-fw text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Satellite'"><i class="fa fa-satellite fa-fw text-inverse text-opacity-50"></i></div>
                  <div class="mb-1 type-icon" *ngIf="fire.incident && fire.incident?.detectionType.displayName == 'Manual Detection'"><i class="bi bi-person-bounding-box fa-fw text-inverse text-opacity-50"></i></div>
                  <h5 *ngIf="fire.incident" class="mb-3">{{fire.incident?.site.name}}</h5>
                  <div *ngIf="fire.incident"class="mb-3 text-inverse text-opacity-50 fw-bold mt-n2">{{fire.incident?.cameraBearing}}°</div>
                  <!--<h5 *ngIf="fire.incident && cameraLatitude && cameraLongitude">({{cameraLatitude}}° {{cameraLongitude}}°)</h5>-->

                  <!-- Status Dropdown - Desktop Only -->
                  <div dropdown class="btn-group d-none d-lg-block mt-3 w-100" *ngIf="fire.incident">
                    <button dropdownToggle type="button" class="btn btn-theme dropdown-toggle w-100" id="statusDropdown" aria-controls="statusDropdownMenu">
                      {{fire.incident?.status.displayName}}
                    </button>
                    <ul id="statusDropdownMenu" *dropdownMenu class="dropdown-menu w-100" role="menu" aria-labelledby="statusDropdown">
                      <li role="menuitem" *ngFor="let status of list">
                        <a class="dropdown-item"
                           *ngIf="status.statusId == fire.incident?.status.statusId || canClickStatus(status)"
                           [class.active]="status.statusId == fire.incident?.status.statusId"
                           [class.disabled]="!canClickStatus(status)"
                           (click)="canClickStatus(status) && updateStatus(status)"
                           [title]="status.description">
                          {{status.displayName}}
                        </a>
                      </li>
                    </ul>
                  </div>
								</div>
							</div>
							<!-- END profile-sidebar -->

							<!-- BEGIN profile-content -->
							<div class="profile-content">
								<ul class="profile-tab nav nav-tabs nav-tabs-v2" role="tablist">
									<li class="nav-item" role="presentation">
										<a href="#profile-inc" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">
											<div class="nav-field">INC #</div>
											<div class="nav-value">{{fire.incident?.incidentId}}</div>
										</a>
									</li>
                  <li class="nav-item" role="presentation">
										<a href="#profile-detect" class="nav-link" data-bs-toggle="tab" aria-selected="true" role="tab">
											<div class="nav-field">Detections</div>
											<div class="nav-value">{{fire.incident?.detections?.length}}</div>
										</a>
									</li>
									<li class="nav-item" role="presentation">
										<a href="#profile-confidence" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
											<div class="nav-field">Confidence</div>
											<div class="nav-value"><div class="nav-value" [ngClass]="{'text-danger':fire.incident?.confidence > 50}"><i class="fa fa-fire"></i> {{fire.incident?.confidence}}%</div></div>
										</a>
									</li>
									<li class="nav-item" role="presentation">
										<a href="#profile-bearing" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
											<div class="nav-field">Bearing</div>
											<div class="nav-value">{{fire.incident?.bearing | number:'1.1-1'}}°</div>
										</a>
									</li>
									<li class="nav-item" role="presentation">
										<a href="#profile-fov" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
											<div class="nav-field">Owner</div>
											<div class="nav-value">{{fire.incident?.incidentOwner ?? "--"}}</div>
										</a>
									</li>
                  <li class="nav-item" role="presentation">
										<a href="#profile-height" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
											<div class="nav-field">Response Time</div>
                      <div class="nav-value" [ngClass]="getResponseTimeClass(fire.incident?.initialResponseTimeSeconds)">{{formatResponseTime(fire.incident?.initialResponseTimeSeconds)}}</div>
										</a>
									</li>
								</ul>
								<div class="profile-content-container">

									<div class="row gx-4">
										<div class="col-xl-12">
											<div class="tab-content p-0">
												<!-- BEGIN tab-pane -->
												<div class="tab-pane fade show active" id="profile-post" role="tabpanel">

												</div>
												<!-- END tab-pane -->

												<!-- BEGIN tab-pane -->
												<div class="tab-pane fade" id="profile-followers" role="tabpanel">

												</div>
												<!-- END tab-pane -->

												<!-- BEGIN tab-pane -->
												<div class="tab-pane fade" id="profile-media" role="tabpanel">


												</div>
												<!-- END tab-pane -->

												<!-- BEGIN tab-pane -->
												<div class="tab-pane fade" id="profile-video" role="tabpanel">

												</div>
												<!-- END tab-pane -->
											</div>

                      <!-- WEATHER DATA - Desktop Version -->
                      <div class="weather-desktop d-none d-lg-block" *ngIf="fire.camera?.weatherStation">
                        <div class="weather-desktop-row" *ngIf="fire.camera.weatherStation.data">
                          <div class="weather-desktop-station">
                            <small>{{fire.camera.weatherStation.siteDescription ?? fire.camera.weatherStation.siteName}}</small>
                          </div>
                          <div class="weather-desktop-item">
                            <i class="bi bi-thermometer-sun"></i>
                            <div class="weather-desktop-value">{{fire.camera.weatherStation.data.AirTemperature?.value | number:'1.1-1' ?? "--"}}°C</div>
                          </div>
                          <div class="weather-desktop-item">
                            <i class="bi bi-droplet"></i>
                            <div class="weather-desktop-value">{{fire.camera.weatherStation.data.RelativeHumidity?.value | number:'1.0-0' ?? "--"}}%</div>
                          </div>
                          <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.WindSpeed?.value">
                            <div class="weather-desktop-item-icon">
                              <svg style="transform:rotate({{fire.camera.weatherStation.data.WindSpeed?.value}}deg);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                              </svg>
                            </div>
                            <div class="weather-desktop-value">{{fire.camera.weatherStation.data.WindSpeed?.value | number:'1.1-1' ?? "-"}} m/s</div>
                          </div>
                          <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.CummulativeRainfall?.value">
                            <i class="bi bi-cloud-rain"></i>
                            <div class="weather-desktop-value">{{fire.camera.weatherStation.data.CummulativeRainfall?.value ?? '--'}} mm</div>
                          </div>
                          <div class="weather-desktop-item" *ngIf="fire.camera.weatherStation.data.AirPressure?.value">
                            <i class="bi bi-speedometer"></i>
                            <div class="weather-desktop-value">{{fire.camera.weatherStation.data.AirPressure?.value | number:'1.0-0' ?? "----"}} hpa</div>
                          </div>
                        </div>
                        <div class="weather-desktop-no-data" *ngIf="!fire.camera.weatherStation.data">
                          <i class="bi bi-cloud-slash text-muted"></i>
                          <div class="text-muted">No weather data in range</div>
                        </div>
                      </div>

                      <!-- WEATHER DATA - Mobile Version -->
                      <div class="weather-mobile d-lg-none" *ngIf="fire.camera?.weatherStation?.data">
                        <div class="weather-mobile-header" *ngIf="fire.camera.weatherStation" (click)="weatherMobileExpanded = !weatherMobileExpanded">
                          <small>{{fire.camera.weatherStation.siteDescription ?? fire.camera.weatherStation.siteName}}</small>
                          <i class="bi" [ngClass]="{'bi-chevron-down': !weatherMobileExpanded, 'bi-chevron-up': weatherMobileExpanded}"></i>
                        </div>
                        <div class="weather-mobile-grid" *ngIf="weatherMobileExpanded">
                          <div class="weather-mobile-item">
                            <i class="bi bi-thermometer-sun"></i>
                            <div class="weather-mobile-value">{{fire.camera.weatherStation.data.AirTemperature?.value | number:'1.1-1' ?? "--"}}°C</div>
                          </div>
                          <div class="weather-mobile-item">
                            <i class="bi bi-droplet"></i>
                            <div class="weather-mobile-value">{{fire.camera.weatherStation.data.RelativeHumidity?.value | number:'1.0-0' ?? "--"}}%</div>
                          </div>
                          <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.WindSpeed?.value">
                            <svg style="transform:rotate({{fire.camera.weatherStation.data.WindSpeed?.value}}deg);"  xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="20" height="20" class="bi bi-arrow-up" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                            </svg>
                            <div class="weather-mobile-value">{{fire.camera.weatherStation.data.WindSpeed?.value | number:'1.1-1' ?? "-"}} m/s</div>
                          </div>
                          <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.CummulativeRainfall?.value">
                            <i class="bi bi-cloud-rain"></i>
                            <div class="weather-mobile-value">{{fire.camera.weatherStation.data.CummulativeRainfall?.value ?? '--'}} mm</div>
                          </div>
                          <div class="weather-mobile-item" *ngIf="fire.camera.weatherStation.data.AirPressure?.value">
                            <i class="bi bi-speedometer"></i>
                            <div class="weather-mobile-value">{{fire.camera.weatherStation.data.AirPressure?.value | number:'1.0-0' ?? "----"}} hpa</div>
                          </div>
                        </div>
                      </div>


                      <div class="btn-group-vertical d-block d-lg-none wide pt-4">
                        <!-- Phone Display -->
                        <!-- if we click on this button for "Investigating", we should then scroll down to the #detection DIV -->
                        <ng-container *ngFor="let status of list">
                          <button type="button" class="btn bg-opacity-25 wide"
                            (click)="updateStatus(status)"
                            *ngIf="status.statusId == this.fire.incident?.status.statusId || canClickStatus(status)"
                            [ngClass]="{
                              'btn-theme bg-white':fire.incident?.status.statusId == status.statusId,
                              'btn-outline-light':canClickStatus(status),
                              'btn-outline-secondary':!canClickStatus(status)
                              }"
                            >{{status.displayName}}</button>
                        </ng-container>
                      </div>
										</div>

									</div>
								</div>
							</div>
							<!-- END profile-content -->

              <div class="profile-sidebar">
								<div class="metadata-section">
                  <!-- Control Status -->
                  <div class="metadata-item" *ngIf="fire && fire.connection">
                    <div class="metadata-value">
                      <span class="signalr-status cursor" (click)="fire.reconnect()">
                        <container-element [ngSwitch]="fire.connection.state">
                            <some-element *ngSwitchCase="'Connected'"><span class="badge bg-success">Online</span></some-element>
                            <some-element *ngSwitchCase="'Disconnected'"><span class="badge bg-danger">Offline</span></some-element>
                            <some-element *ngSwitchDefault><span class="badge bg-secondary">{{fire.connection.state}}</span></some-element>
                        </container-element>
                      </span>
                    </div>
                  </div>

                  <!-- Location Group (Coordinates + UTM merged) -->
                  <div class="metadata-group" *ngIf="(fire.incident?.initialLocationLat && fire.incident?.initialLocationLon) || (fire.incident?.initialEasting && fire.incident?.initialNorthing && fire.incident?.initialUTMZone)">
                    <div class="metadata-group-title">
                      Location
                    </div>
                    <table class="metadata-table">
                      <tbody>
                        <tr *ngIf="fire.incident?.initialLocationLat && fire.incident?.initialLocationLon">
                          <th>Coordinates</th>
                          <td>{{fire.incident?.initialLocationLat | number : '1.2-3'}}°, {{fire.incident?.initialLocationLon | number : '1.2-3'}}°</td>
                        </tr>
                        <ng-container *ngIf="fire.incident?.initialEasting && fire.incident?.initialNorthing && fire.incident?.initialUTMZone">
                          <tr>
                            <th>Zone</th>
                            <td>Z{{fire.incident?.initialUTMZone}}</td>
                          </tr>
                          <tr>
                            <th>Easting</th>
                            <td>{{fire.incident?.initialEasting}}E</td>
                          </tr>
                          <tr>
                            <th>Northing</th>
                            <td>{{fire.incident?.initialNorthing}}N</td>
                          </tr>
                          <tr>
                            <th>Distance</th>
                            <td>{{fire.incident?.initialDistance}}km</td>
                          </tr>
                          <tr>
                            <th>Bearing</th>
                            <td>{{fire.incident?.initialBearing}}°</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>

                  <!-- Reference -->
                  <div class="metadata-item" *ngIf="fire.incident?.incidentReference">
                    <div class="metadata-label">Reference #</div>
                    <div class="metadata-value">
                      <span *ngIf="fire.incident?.incidentReferenceUrl == null">
                        {{fire.incident?.incidentReference}}
                      </span>
                      <a *ngIf="fire.incident?.incidentReferenceUrl != null"
                         href="{{fire.incident?.incidentReferenceUrl}}"
                         target="_blank"
                         class="reference-link">
                        {{fire.incident?.incidentReference}}
                      </a>
                    </div>
                  </div>

                  <!-- Camera Settings -->
                  <div class="metadata-group" *ngIf="fire.incident?.site != null">
                    <div class="metadata-group-title">
                      Camera Details
                    </div>
                    <table class="metadata-table">
                      <tbody>
                        <tr>
                          <th>Tower Altitude (AHD)</th>
                          <td>{{fire.incident?.site?.cameraAltitude}}</td>
                        </tr>
                        <tr>
                          <th>Camera Height (AGL)</th>
                          <td>{{fire.incident?.site?.cameraHeight}}</td>
                        </tr>
                        <tr>
                          <th>Roll Error</th>
                          <td>{{fire.incident?.site?.rollError}}</td>
                        </tr>
                        <tr>
                          <th>Pitch Error</th>
                          <td>{{fire.incident?.site?.pitchError}}</td>
                        </tr>
                        <tr>
                          <th>Yaw Error</th>
                          <td>{{fire.incident?.site?.yawError}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Start Time -->
                  <div class="metadata-item" *ngIf="fire.incident">
                    <div class="metadata-label">Start Time</div>
                    <div class="metadata-value">
                      {{fire.incident?.fireIncidentDate | date:'short'}}<br/>
                      <small class="text-muted">{{fire.incident?.fireIncidentDate | relativeDate:true}}</small>
                    </div>
                  </div>

								</div>
							</div>
						</div>
						<!-- END profile-container -->
					</div>
					<!-- END profile -->
				</div>
			</div>

    </div>
  </div>

  <div class="row gx-4 mt-2">

    <!-- Images -->

    <div class="col-xl-6 col-xxl-5">

      <!-- Detection Images -->

      <div id="detection" class="card mb-4" *ngIf="fire.incident" [ngClass]="{'card-expand':detectExpand}">
        <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
          <span class="flex-grow-1">[{{getModeName()}}]</span>

          <a *ngIf="fire.incident" title="Edit fire location" class="cursor text-inverse text-opacity-50 text-decoration-none mr" (click)="changeMode(5)">
            <i class="bi" [ngClass]="{'bi-pencil':mode != 5,'bi-pencil-fill':mode == 5}"></i>
          </a>

          <!-- day/night mode toggle - with hover view -->
          <a *ngIf="fire.incident" class="text-inverse text-opacity-50 text-decoration-none cursor mr" title="Day Time" (click)="changeMode(4)" (mouseenter)="changeMode(40, 1)" (mouseleave)="changeMode(40, 0)">
            <i class="bi" [ngClass]="{'bi-sun':mode != 4 && mode != 40,'bi-sun-fill':mode == 4 || mode == 40}"></i>
          </a>

          <!-- detection mode toggle - with hover view -->
          <a *ngIf="fire.incident" title="Detection Mode" class="text-inverse text-opacity-50 text-decoration-none cursor mr" (click)="changeMode(7)" (mouseenter)="changeMode(70, 1)" (mouseleave)="changeMode(70, 0)">
            <i class="bi" [ngClass]="{'bi-bounding-box-circles':mode != 7 && mode != 70,'bi-bounding-box':mode == 7 || mode == 70}"></i>
          </a>

          <!-- latest image - with hover view -->
          <a class="text-inverse text-opacity-50 text-decoration-none cursor mr" title="Latest Image" (click)="changeMode(1)" (mouseenter)="changeMode(10, 1)" (mouseleave)="changeMode(10, 0)">
            <i class="bi" [ngClass]="{'bi-clock-history':mode != 1 && mode != 10, 'bi-clock-fill':mode == 1 || mode == 10}"></i>
          </a>

          <!-- zoomed image - with hover view -->
          <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor mr" title="Zoomed Image" (click)="changeMode(3)" (mouseenter)="changeMode(30, 1)" (mouseleave)="changeMode(30, 0)" [disabled]="!fire.incident?.firstZoomedImageUrl">
            <i class="bi" [ngClass]="{'bi-zoom-in': mode != 3 && mode != 30,'bi-zoom-out': mode == 3 || mode == 30}"></i>
          </a>

          <!-- video feed -->
          <a (click)="changeMode(2)" data-toggle="card-expand" style="cursor: pointer;" title="Video Feed" class="text-inverse text-opacity-50 text-decoration-none cursor mr" [disabled]="!this.fire.camera?.canStream">
            <i class="bi" [ngClass]="{'bi-camera-video':mode != 2,'bi-camera-video-fill':mode == 2}"></i>
          </a>

          <a *ngIf="fire.incident" data-toggle="card-expand" title="Full Screen" class="text-inverse text-opacity-50 text-decoration-none cursor" title="Expand image" (click)="detectExpand = !detectExpand">
            <i class="bi bi-fullscreen"></i>
          </a>
        </div>
        <div class="card-body p-0">
          <div *ngIf="fire.incident">
            <!-- Detection Images -->
            <smart-image-list #incidentImage *ngIf="mode == 7 || mode == 70" (pointerEvent)="displayDirection($event)" (clickEvent)="onImageClick($event)" (onImageIndexChange)="imageIndexChanged($event)" [showZones]="showZones" [zones]="zones" [showLineAt]="showLineAt" [showMetaData]="true" [images]="detectionImages"></smart-image-list>  
            <!-- Latest Images -->
            <smart-image-list *ngIf="mode == 6 || mode == 1 || mode == 10 || mode == 60" [showLineAt]="showLineAt" [images]="latestImages" [overlayConfig]="fire.incident.detections[0].detectionMetaData" [showMetaData]="true"></smart-image-list>
            <!-- Zoomed Images -->
            <smart-image-list *ngIf="mode == 3 || mode == 30" [showLineAt]="false" [images]="latestZoomedImages" ></smart-image-list>
            <!-- Day Mode Image -->
            <smart-image *ngIf="mode == 4 || mode == 40" [src]="fire.incident.dayTimeModeImageUrl" [overlayConfig]="fire.incident.detections[0].detectionMetaData" [showMetaData]="true"></smart-image>
            <!-- Image Classifier -->
            <app-image-classifier *ngIf="mode == 5" [imageSrc]="detectionImages[selectedImageIndex].src" (onSelectionComplete)="fireLocationUpdated($event)"></app-image-classifier>
            <!-- Day Mode Active Indicator -->
            <div class="day-mode-pad" *ngIf="mode == 4 || mode == 40">Day Mode Active</div>
            
            <!-- video feed -->
            <img *ngIf="mode == 2 && liveStreaming && streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="streamUrl" alt="Axis Camera Stream">
            <img *ngIf="mode == 2 && liveStreaming && !streamUrl" class="animate__animated animate__fadeIn" #livestream [src]="'/assets/images/connecting.png'" alt="Axis Camera Stream">
          </div>
        </div>
      </div>


    </div>

    <!-- Map -->

    <div class="col-xl-6 col-xxl-5">

      <!-- Map -->

      <div class="card mb-4"  [ngClass]="{'card-expand':mapExpand}">
        <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
          <span class="flex-grow-1">Map</span>
          
          <span (click)="toggleLocationSelect(false)" class="badge bg-danger" *ngIf="fire.incident && fire.incident?.status && (fire.incident?.status.statusId == 2 || fire.incident?.status.statusId == 7)">Location Required</span>

          <a (click)="toggleLocationSelect(false)"  style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none mr">
            <i [ngClass]="{'bi-geo-alt':!locationSelectActive,'bi-geo-alt-fill':locationSelectActive}" class="bi"></i>
          </a>

          <a (click)="toggleFireSpread()" *ngIf="fire.incident?.hasFireSpreadModel" style="cursor: pointer;" title="Fire Spread Model" class="text-inverse text-opacity-50 text-decoration-none mr">
            <i [ngClass]="{'bi-compass':!fireSpreadSelected,'bi-compass-fill':fireSpreadSelected}" class="bi"></i>
          </a>

          <a (click)="toggleLayers()" style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none mr">
            <i [ngClass]="{'bi-layers':!layersSelected,'bi-layers-fill':layersSelected}" class="bi"></i>
          </a>

          <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor" title="Expand image" (click)="mapExpand = !mapExpand;resizeMap()">
            <i class="bi bi-fullscreen"></i>
          </a>

        </div>
        <div class="card-body p-0">
          <div class="py-2 d-flex flex-row-reverse overlay" *ngIf="locationSelectActive">
            <button class="btn btn-sm btn-primary mx-1" (click)="toggleLocationSelect(true)">Confirm Location</button>
            <button class="btn btn-sm btn-outline-secondary mx-1" (click)="toggleLocationSelect(false)">Cancel</button>
          </div>

          <!-- Fire Spread Animation Controls -->
          <div class="fire-spread-controls" *ngIf="fireSpreadSelected && fireSpreadModel" style="position: absolute; bottom: 10px; left: 10px; right: 10px; z-index: 1000; background: rgba(0,0,0,0.75); padding: 15px; border-radius: 8px; color: white;">
            <div class="d-flex align-items-center mb-2">
              <div class="flex-grow-1">
                <strong>Fire Spread Model</strong>
                <div style="font-size: 0.85em; opacity: 0.9;">
                  Frame {{ currentFrameIndex + 1 }} of {{ fireSpreadModel.frames?.length }} - {{ getFireSpreadFrameTimestamp() }}
                </div>
              </div>
              <button class="btn btn-sm btn-danger" (click)="toggleFireSpread()" title="Close">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            
            <div class="d-flex align-items-center gap-2 mb-2">
              <button class="btn btn-sm btn-secondary" (click)="stepFireSpreadBackward()" title="Previous Frame">
                <i class="bi bi-skip-backward-fill"></i>
              </button>
              <button class="btn btn-sm btn-primary" (click)="toggleFireSpreadAnimation()" title="Play/Pause">
                <i class="bi" [ngClass]="isAnimating ? 'bi-pause-fill' : 'bi-play-fill'"></i>
              </button>
              <button class="btn btn-sm btn-secondary" (click)="stepFireSpreadForward()" title="Next Frame">
                <i class="bi bi-skip-forward-fill"></i>
              </button>
            </div>
            
            <input 
              type="range" 
              class="form-range" 
              [min]="0" 
              [max]="fireSpreadModel.frames?.length - 1" 
              [(ngModel)]="currentFrameIndex" 
              (input)="setFireSpreadFrame(currentFrameIndex)"
              style="width: 100%;">
          </div>

          <app-map #cameramap
            [mapheight]="mapHeight"
            [mapType]="'googleSat'"
            [location]="location"
            [elevationProfile]="elevationProfile"
            [showElevationChart]="!!elevationProfile"></app-map>
        </div>
      </div>

      <!-- Data -->
      <div class="row">

        

      </div>

    </div>

    <!-- Notes -->

    <div class="col-xl-6 col-xxl-1">
      <div class="card mb-4 notes">
        <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <div class="flex-1">
            <div>Notes</div>
          </div>
        </div>
        <div #chat class="card-body bg-inverse bg-opacity-10 sc scroll" style="height:100%" data-scrollbar="true" data-height="100%" data-init="true">
          <div class="widget-chat" *ngIf="fire && fire.incident">
            <div class="widget-chat-item" *ngFor="let note of fire.incident?.notes" [ngClass]="{'reply':note.lastModifiedBy != security.account.name}">
              <div class="widget-chat-media"><img src="assets/img/user/user-2.jpg" alt="" /></div>
              <div class="widget-chat-content">
                <div class="widget-chat-name">{{note.lastModifiedBy}}</div>
                <div class="widget-chat-message">
                  {{note.notes}}
                </div>
                <div class="widget-chat-status" [title]="note.lastModifiedDate">{{note.lastModifiedDate | relativeDate}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Add new notes..." [(ngModel)]="newNote"  (keydown)="onCommentKeyDown($event)">
            <button class="btn btn-outline-default" type="button" (click)="addNewNote()"><i class="fa fa-paper-plane text-muted"></i></button>
          </div>
        </div>
      </div>
    </div>

    <!-- Metadata -->

    <div class="col-xl-6 col-xxl-1" >
      <div class="card mb-4 metadata">
        <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <div class="flex-1">
            <div>Meta Data</div>
          </div>
        </div>
        <div class="card-body bg-inverse bg-opacity-10" style="max-height: 780px; overflow-y: auto;" *ngIf="fire && fire.incident && incidentId">
          <div class="form-group mb-3" >
            <label class="form-label bold">Incident Title</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="fire.incident.incidentTitle"/>
          </div>

          <div class="form-group mb-3" *ngIf="fire.incident?.initialLocationLat && fire.incident?.initialLocationLon">
            <label class="form-label bold">Location</label>
            <div class="form-control form-control-sm bg-secondary bg-opacity-10">
              {{fire.incident?.initialLocationLat | number : '1.2-3'}}° , {{fire.incident?.initialLocationLon | number : '1.2-3'}}°
            </div>
          </div>

          <div class="form-group mb-3" *ngIf="fire.incident?.initialEasting && fire.incident?.initialNorthing && fire.incident?.initialUTMZone">
            <label class="form-label bold">UTM</label>
            <div class="form-control form-control-sm bg-secondary bg-opacity-10">
              {{fire.incident?.initialEasting}}E , {{fire.incident?.initialNorthing}}N
            </div>
          </div>

          <div class="form-group mb-3" *ngIf="fire.incident?.initialEasting && fire.incident?.initialNorthing && fire.incident?.initialUTMZone">
            <label class="form-label bold">Zone</label>
            <div class="form-control form-control-sm bg-secondary bg-opacity-10">
              Z{{fire.incident?.initialUTMZone}}
            </div>
          </div>

          <div class="form-group mb-3" *ngIf="fire.incident?.initialDistance">
            <label class="form-label bold">Distance</label>
            <div class="form-control form-control-sm bg-secondary bg-opacity-10">
              {{fire.incident?.initialDistance}}km
            </div>
          </div>

          <div class="form-group mb-3" *ngIf="fire.incident?.initialBearing">
            <label class="form-label bold">Bearing</label>
            <div class="form-control form-control-sm bg-secondary bg-opacity-10">
              {{fire.incident?.initialBearing}}°
            </div>
          </div>

          <div class="form-group mb-3" *ngIf="responsibleParties">
            <label class="form-label bold">Responsible Party</label>
            <select [(ngModel)]="fire.incident.responsiblePartyId" class="form-select form-select-sm" [ngClass]="{'is-invalid':fire.incident?.responsiblePartyId == null}" required>
              <option *ngFor="let t of responsibleParties" [value]="t.responsiblePartyId">{{t.displayName}}</option>
            </select>
          </div>

          <div class="form-group mb-3">
            <label class="form-label bold">Reference #</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="fire.incident.incidentReference"/>
          </div>

          <div class="form-group mb-3">
            <label class="form-label bold">Reference URL</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="fire.incident.incidentReferenceUrl"/>
          </div>

          <div class="form-group mb-3">
            <label class="form-label bold">Incident Start</label>
            <app-date-time [(ngModel)]="fire.incident.incidentStartDate"></app-date-time>
          </div>

          <div class="form-group mb-3">
            <label class="form-label bold">Incident End</label>
            <app-date-time [(ngModel)]="fire.incident.incidentEndDate"></app-date-time>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-sm btn-theme btn-block" (click)="updateIncident()">Save</button>
        </div>
      </div>
    </div>

  </div>
  <div class="row gx-4 mt-2">
    <div class="col-lg-6">

    </div>

</div>

<div class="row gx-4 mt-2" *ngIf="fire.incident && (fire.incident?.status.statusId == 8 || fire.incident?.status.statusId == 9)">
  <div class="col-lg-6">
    <h1 class="h2">STT Contacts and Escalations</h1>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Location</th>
          <th>Area</th>
          <th>1st Level Escalation</th>
          <th class="d-none d-lg-table-cell">2nd Level Escalation</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Doody's</td>
          <td rowspan="5">South</td>
          <td rowspan="5">
            <a href="mailto:fire.south@sttas.com.au">fire.south@sttas.com.au</a><br/>
            <a href="tel:0362358111">03 62 358 111</a>
          </td>
          <td rowspan="5" class="d-none d-lg-table-cell">
            <a href="mailto:jye.hill@sttas.com.au">jye.hill@sttas.com.au</a><br/>
            <a href="tel:0407282885">0407 282 885</a>
          </td>
        </tr>
        <tr>
          <td>Snow</td>
        </tr>
        <tr>
          <td>Tyler's</td>
        </tr>
        <tr>
          <td>Moaners</td>
        </tr>
        <tr>
          <td>Brady's</td>
        </tr>
        <tr>
          <td>South Sisters</td>
          <td rowspan="4">North</td>
          <td rowspan="4">
            <a href="mailto:fire.south@sttas.com.au">fire.north@sttas.com.au</a><br/>
            <a href="tel:0363987007">03 6398 7007</a>
          </td>
          <td rowspan="4" class="d-none d-lg-table-cell">
            <a href="mailto:brodie.frost@sttas.com.au">brodie.frost@sttas.com.au</a><br/>
            <a href="tel:0428453203">0428 453 203</a>
          </td>
        </tr>
        <tr>
          <td>Mt Horror</td>
        </tr>
        <tr>
          <td>Tower Hill</td>
        </tr>
        <tr>
          <td>Mt Arthur</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-lg-6">
    <h1 class="h2">Tas Fire Escalation</h1>
    <div class="list-group">
      <a class="list-group-item list-group-item-action"><b>Introduction:</b><br/>"Hello, I’m calling on behalf of Fire Foresight, a bushfire detection service working in Tasmania. We have detected a potential fire that requires your awareness.”</a>
      <a class="list-group-item list-group-item-action"><b>Location of the Fire (Use a recognised geographical location, not a coupe ID, forestry road name or spur number):</b><br/> “The fire has been detected at [location or coordinates].“</a>
      <a class="list-group-item list-group-item-action"><b>Description of Detection:</b><br/> "Our system has identified smoke from [camera location]. The first detection occurred at approximately [time detected]. The detection location/coordinates are [description of area, e.g., rural/forest region, provide LAT/LONG, or EASTING/NORTHINGS if confident to do so].“</a>
      <a class="list-group-item list-group-item-action"><b>Request Incident Number (Ask Firecomm for an Incident Number for the report and record this in FF incident chat):</b><br/> “Could we request an incident number for our records to be shared with [customer]?”</a>
      <a class="list-group-item list-group-item-action"><b>Contact for Follow-up:</b><br/> “Please contact us on 0498 855 120 if further information is required, we can provide authorities with a video feed if required.”</a>
    </div>

  </div>
</div>


<div class="row" *ngIf="timelines">
  <div class="col-lg-12">
    <h1 class="h2">Timeline</h1>
    <div class="timeline-container">
      <div class="timeline-item" *ngFor="let event of timelines; let i = index">
        <div class="timeline-marker">
          <div class="timeline-dot"></div>
        </div>
        <div class="timeline-content">
          <div class="timeline-header">
            <div class="timeline-time">
              <div class="time-primary">{{event.time | date:'yy/MM/dd HH:mm:ss'}}</div>
              <div class="time-relative">{{event.time | relativeDate}}</div>
            </div>
            <div class="timeline-meta">
              <span class="timeline-type badge bg-primary">{{event.type}}</span>
              <div class="timeline-by" *ngIf="event.by">{{event.by}}</div>
            </div>
          </div>
          <div class="timeline-text" *ngIf="event.text">
            {{event.text}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


</div>
